import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';
import ColorSwatchWrapper from 'components/search/ColorSwatches';
import ProductCard from 'components/common/ProductCard';
import useEffectOnce from 'hooks/useEffectOnce';
import { trackSponsoredAdImpression } from 'hooks/useSponsoredAds';

import css from 'styles/components/search/sponsoredAds.scss';

const SponsoredAdsProduct = ({
  product,
  relatedStyles,
  makeSponsoredAdClick,
  msaImageParams,
  CardBottomSlot,
  isInCarousel,
  isFullMaxWidth,
  includeSwatchRowSpace,
  clickThruUrl,
  amazonAdsEventUrl
}) => {
  const { testId } = useMartyContext();
  const { index } = product;
  const linkProps = { 'aria-describedby': `sponsoredBanner-${index}` };

  // Collapse the reserved swatch row on grid sponsored cards, keeping it only inside carousels.
  const shouldIncludeSwatchRowSpace = isInCarousel && includeSwatchRowSpace;

  /**
   * Important: "Impression" events are fired when the ad is rendered on the page
   */
  useEffectOnce(() => {
    if (typeof window !== 'undefined' && product.impressionUrl) {
      trackSponsoredAdImpression({ url: product.impressionUrl });
    }
  });

  if (relatedStyles?.length) {
    return (
      <ColorSwatchWrapper
        index={index}
        className={cn({
          [css.sponsoredAdsCard]: !isInCarousel,
          [css.displaySixCardTiles]: isFullMaxWidth
        })}
        {...product}
        relatedStyles={relatedStyles}
        msaImageParams={msaImageParams}
        onClick={makeSponsoredAdClick(product, index, amazonAdsEventUrl, relatedStyles)}
        data-test-id={testId('amazonAdsWrappedCard')}
        CardBottomSlot={CardBottomSlot}
        linkProps={linkProps}
        clickThruUrl={clickThruUrl}
      />
    );
  }

  return (
    <ProductCard
      index={index}
      className={cn({
        [css.sponsoredAdsCard]: !isInCarousel,
        [css.displaySixCardTiles]: isFullMaxWidth
      })}
      msaImageParams={msaImageParams}
      onClick={makeSponsoredAdClick(product, index, amazonAdsEventUrl, relatedStyles)}
      {...product}
      data-test-id={testId('amazonAdsWrappedCard')}
      CardBottomSlot={CardBottomSlot}
      linkProps={linkProps}
      includeSwatchRowSpace={shouldIncludeSwatchRowSpace}
      clickThruUrl={clickThruUrl}
    />
  );
};

export default SponsoredAdsProduct;
